"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('../../../ui/js/api-header-injector.js');
require('hacktimer');
require('../css/simplebar.css');
require('../css/bootstrap.min.css');
require('webpack-jquery-ui');
require('webpack-jquery-ui/css');
require('../js/jquery-3.3.1.min.js');
require('../js/bootstrap.bundle.min.js');
require('../js/simplebar.min.js');
require('../scss/style.scss');
switch (window.location.hostname) {
    case BABAIJEBU_DOMAIN:
        try {
            require('../scss/' + BABAIJEBU_DOMAIN + '.scss');
        }
        catch (e) {
            console.info(e);
        }
        break;
    case AMELCO_DOMAIN:
        try {
            require('../scss/' + AMELCO_DOMAIN + '.scss');
        }
        catch (e) {
            console.info(e);
        }
        break;
}
require.context('../img', true, /\.(gif|png|jpe?g|svg)$/i);
require('../../../ui/js/chart.min.js');
require('../../../ui/js/jquery.mCustomScrollbar.js');
require('../../../ui/js/charts.js');
window['getUrlParam'] = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    }
    else {
        return decodeURI(results[1]) || 0;
    }
};
var MultiLanguage = require('../js/multilanguage.js').MultiLanguage;
require('../js/layout.js');
require('../js/socket.io');
require('../../../ui/js/language.js');
require('../js/menu.js');
window['lang'] = window['getUrlParam']('lang');
window.LABEL = new MultiLanguage();
var paramLang = window.lang;
if (typeof paramLang !== 'undefined' && paramLang !== null) {
    LABEL.loadLangPack(paramLang, function () {
        console.log('ML IS_READY MOMENT', LABEL);
    });
}
else {
    LABEL.loadLangPack("en", function () {
        console.log('Loading default en language.', LABEL);
    });
}
var socket_connector_1 = require("../js/socket-connector");
var get_config_1 = require("../ts/get-config/get-config");
var amount_1 = require("../ts/components/betting/amount/amount");
var amount_2 = require("./listeners/betting/amount");
var challneges_1 = require("./listeners/betting/challneges");
var name_1 = require("./listeners/betting/name");
var submit_1 = require("./listeners/betting/submit");
var modal_1 = require("./listeners/modals/modal");
var index_1 = require("./coin-animation/index");
var animation_storage_1 = require("./coin-animation/animation-storage");
var redux_1 = require("redux");
var index_2 = require("./store/index");
var history_1 = require("./components/history/history");
var api_1 = require("./api/api");
var user_1 = require("./user/user");
var auth_1 = require("./auth/auth");
var login_modal_helper_1 = require("./helpers/login-modal-helper");
var credit_1 = require("./credit/credit");
var cookie_helper_1 = require("./helpers/cookie-helper");
var navbar_display_1 = require("./navbar/navbar-display");
var get_game_1 = require("./get-game/get-game");
var parent_window_1 = require("./listeners/parent-window/parent-window");
var chat_1 = require("../../lucky-balls/js/chat");
window['API_URL'] = API_URL;
var SPECIAL_API_URL = 'https://api.elbet.us/index.php';
var SPECIAL_API_URL_DOMAINS = ['online.try.everymatrix.elbet.us', 'localhost'];
if (SPECIAL_API_URL_DOMAINS.indexOf(window.location.hostname) >= 0) {
    window['API_URL'] = SPECIAL_API_URL;
    console.log('Special API URL for domain ' + window.location.hostname + ' : ' + SPECIAL_API_URL);
}
window['$'] = require('jquery');
window['jquery'] = window['$'];
window['jQuery'] = window['$'];
window['token'] = window['getUrlParam']('token');
var animationStorage = new animation_storage_1.default();
animationStorage.load();
window.addEventListener('coinsLoaded', function (e) {
    var bootstrap = new index_1.default();
    bootstrap.init();
    var store = redux_1.createStore(index_2.rootReducer);
    var getGame = new get_game_1.default();
    getGame.settings().then(function (data) {
        var amounts = new amount_1.default();
        var histories = new history_1.default();
        histories.render(data.Data.ChallengeHistory);
        amounts.render(data.Data.BetValue);
        amount_2.default.listen(store);
        challneges_1.default.listen(store);
        name_1.default.listen(store);
        submit_1.default.listen(store);
        modal_1.default.listen();
        parent_window_1.default.listen(store);
    });
    var getConfig = new get_config_1.default();
    getConfig.getConfig().then(function (data) {
        var api = new api_1.default(window['API_URL'] + '/fast-coin');
        var user = new user_1.default();
        var auth = new auth_1.default(api);
        var credit = new credit_1.default(api);
        var navbar = new navbar_display_1.default();
        socket_connector_1.socketConnector(e.detail, store, data['FastCoin_Node_URL']);
        window['loggedOut'] = new Event("loggedOut");
        window.addEventListener('logout', function () {
            auth.logout();
        });
        window.addEventListener('get_credit', function () {
            credit.getCredit(user);
        });
        window.addEventListener('payout', function () {
            credit.requestPayout(user);
        });
        loginManagement(auth, user, navbar, credit);
        window['menu'] = (data['Online_Menu'] !== undefined && data['Online_Menu'] !== '' && data['Online_Menu'] != null) ? data['Online_Menu'] : false;
        window['showLogin'] = (data['showLogin'] !== undefined && data['showLogin'] != '' && data['showLogin'] != null) ? data['showLogin'] : 0;
        window['currency'] = data['Currency'] || '';
        window['customLoggedIn'] = false;
        window['customToken'] = '';
        if (window['showLogin'] != 1 || cookie_helper_1.default.get('token') == '') {
            window['token'] = window['getUrlParam']('token');
        }
        else {
            window['token'] = cookie_helper_1.default.get('token');
        }
        $("#citgLeft").text(LABEL.store.amount + "(" + (cookie_helper_1.default.get('currency') || window['currency']) + ")");
        $("#citgRight").text(LABEL.store.name + ":");
        if (window['token'] && !/terminal/.test(window.location.href)) {
            chat_1.chat(window['token']);
        }
        if (window['menu'] && !/electron=true/.test(window.location.href)) {
            document.body.style.opacity = '1';
            $("#nav-icon1").show();
            $('.terminal-left').show();
            window['renderMenu']();
        }
        else {
            document.body.style.opacity = '1';
            var contentTab = document.querySelector(".terminal-content-tabs");
            var contentTabs = document.querySelector(".terminal-tabs");
            if (contentTab) {
                contentTab.classList.add("terminal-full-width");
            }
            if (contentTabs) {
                contentTabs.classList.add("terminal-full-width");
            }
        }
        if (window['showLogin'] == 1) {
            $('.game-nav-bar').css('display', 'flex');
            $('#mainWrapper').addClass('navbar-height');
        }
        else {
            $('.game-nav-bar').css('display', 'none');
            $('#mainWrapper').removeClass('navbar-height');
        }
    });
}, false);
$('.payout-pin-button').click(function () {
    var payoutEvent = new CustomEvent("payout");
    window.dispatchEvent(payoutEvent);
});
function loginManagement(auth, user, navbar, credit) {
    if (user.isLogggedIn()) {
        window['token'] = cookie_helper_1.default.get('token');
        var response = {
            Data: {
                AuthUserResponse: [
                    {
                        Credit: credit.getCredit(user),
                        Currency: cookie_helper_1.default.get('currency')
                    }
                ]
            }
        };
        navbar.showLogedIn(user, response);
    }
    else {
        navbar.showLogedOut();
        window['token'] = window['getUrlParam']('token');
    }
    $('.logout-button').click(function () {
        var logoutEvent = new CustomEvent("logout");
        window.dispatchEvent(logoutEvent);
    });
    $('.login-button').click(function () {
        $('.login-modal').modal('show');
    });
    $('.login-user-button').click(function () {
        auth.login(login_modal_helper_1.default.bind(user));
    });
    $('.user-username').on('keydown', function (e) {
        if (e.which == 13) {
            auth.login(login_modal_helper_1.default.bind(user));
        }
    });
    $('.user-password').on('keydown', function (e) {
        if (e.which == 13) {
            auth.login(login_modal_helper_1.default.bind(user));
        }
    });
    $('.login-modal').on('hidden.bs.modal', function () {
        login_modal_helper_1.default.clearloginInputs();
    });
    $('.login-modal').on('hidden.bs.modal', function () {
        login_modal_helper_1.default.clearloginInputs();
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/main.ts
// module id = 2255
// module chunks = 5